function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0597 6H9.99967V2.66667C9.99967 2.3 9.69967 2 9.33301 2H6.66634C6.29967 2 5.99967 2.3 5.99967 2.66667V6H4.93967C4.34634 6 4.04634 6.72 4.46634 7.14L7.52634 10.2C7.78634 10.46 8.20634 10.46 8.46634 10.2L11.5263 7.14C11.9463 6.72 11.653 6 11.0597 6ZM3.33301 12.6667C3.33301 13.0333 3.63301 13.3333 3.99967 13.3333H11.9997C12.3663 13.3333 12.6663 13.0333 12.6663 12.6667C12.6663 12.3 12.3663 12 11.9997 12H3.99967C3.63301 12 3.33301 12.3 3.33301 12.6667Z",
  fill: "#30327F"
});
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f67d92657f6bf56c6a4214f8e8b2a523.svg";
export { ForwardRef as ReactComponent };